<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Konfiguracja - Firma <small class="text-red-400 text-xs">(Wszystkie pola wymagane)</small></h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-3/4">

        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <multiselect-input v-model="form.firma" :error="form.errors.firma" class="pr-6 pb-8 w-full" :options="firmy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Domyślna firma dla CRM'u" :isDisabled="!$page.props.can['update configs']" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['update configs']" >
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zapisz konfigurację</loading-button>
          </div>
            
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Konfiguracja - Firma' },
  components: {
    LoadingButton,
    MultiselectInput
  },
  layout: Layout,
  remember: 'form',
  props: {
    firma: Object,
    firmy: Array
  },
  data() {
    return {
      form: this.$inertia.form({
        firma: this.firma,
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('configs.firm.update'))
    },
  },
}
</script>
